/**
 * Watchlist storage, framework-free, so the API layer can prune it on a
 * prospect delete. The React side is hooks/useWatchlist.
 */

import { getPref, setPref } from './userPreferences'

export const WATCHLIST_LIMIT = 200
export const WATCHLIST_CHANGED = 'dealpoint:watchlist-changed'

export function readWatchlist(): Set<string> {
  const list = getPref('prospect_watchlist')
  return new Set(Array.isArray(list) ? list.filter(id => typeof id === 'string') : [])
}

function writeWatchlist(next: Set<string>): void {
  setPref('prospect_watchlist', [...next])
  window.dispatchEvent(new CustomEvent(WATCHLIST_CHANGED))
}

export function addToWatchlist(id: string): void {
  const next = readWatchlist()
  if (next.has(id)) return
  if (next.size >= WATCHLIST_LIMIT) throw new Error(`Watchlist is full (${WATCHLIST_LIMIT}). Take someone off it first.`)
  next.add(id)
  writeWatchlist(next)
}

export function removeFromWatchlist(id: string): void {
  const next = readWatchlist()
  if (!next.delete(id)) return
  writeWatchlist(next)
}
